var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_18339)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 -5H-8V369H654V-5Z",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9222 47.5078H41.5527L30.8679 65.9987L41.5527 84.4845H62.9222L73.6121 65.9987L62.9222 47.5078Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.958 58.418L43.7898 71.9035",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0215 59.0938L64.3727 72.7017",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6121 65.9998H89.4043L103.113 87.3378L113.236 52.7031L123.21 86.9806L133.333 52.7031L144.243 87.3378L155.081 53.1317L165.704 86.4041L175.679 54.2083L187.881 86.2612L197.789 53.2083L212.146 87.9807L218.602 67.0458H250.043",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.64 45.6875H250.61V83.6795H288.64V45.6875Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.929 75.9358H263.583V62.9605C263.583 59.2817 266.571 56.2969 270.254 56.2969C273.936 56.2969 276.924 59.2817 276.924 62.9605V75.9358H276.929Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1677 308.908V272.141L74.5314 290.524L44.1677 308.908Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5315 290.526H162.063V254.805",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.211 255.263C167.311 255.263 171.445 251.132 171.445 246.038C171.445 240.943 167.311 236.812 162.211 236.812C157.111 236.812 152.977 240.943 152.977 246.038C152.977 251.132 157.111 255.263 162.211 255.263Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2424 277.031V84.4844",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63 158.342V83.6797",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63 268.319V196.039",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63 196.061C280.062 196.061 288.518 187.613 288.518 177.193C288.518 166.772 280.062 158.324 269.63 158.324C259.199 158.324 250.743 166.772 250.743 177.193C250.743 187.613 259.199 196.061 269.63 196.061Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.502 300.975V279.209L269.63 268.32L250.753 279.209V300.975L269.63 311.864L288.502 300.975Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.079 229.446H123.798C118.369 229.446 113.966 225.048 113.966 219.624V135.701C113.966 130.277 118.369 125.879 123.798 125.879H206.079C211.508 125.879 215.911 130.277 215.911 135.701V219.624C215.911 225.048 211.508 229.446 206.079 229.446Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.78 174.455L174.127 200.987L146.424 176.052L172.502 148.969L198.78 174.455Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.127 200.987H158.104L132.22 175.664L158.268 148.969H172.502L146.424 176.052L174.127 200.987Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.636 168.02V186.271",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.819 177.188H260.55",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.55 316.822H427.098C420.049 316.822 414.334 311.112 414.334 304.071C414.334 297.03 420.049 291.32 427.098 291.32H502.55C509.598 291.32 515.313 297.03 515.313 304.071C515.313 311.112 509.598 316.822 502.55 316.822Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.082 82.4736V67.4626H317.666V43.9102H609.132V291.323H567.992V304.073H515.313",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.502 291.32H361.488V304.071H414.34",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.036 97.4072L460.664 82.4727H478.131L470.036 97.4072Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.191 98H334.955V273.75H592.191V98Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.27 200.154C471.737 206.619 477.29 212.841 478.846 225.023C483.25 259.5 470.442 270.432 467.25 273.75H592.5V98H469.27C473.124 103.077 480.833 119.507 480.833 144.615C481.191 157.34 478.177 173.357 469.413 193.792C468.545 195.817 468.488 198.093 469.27 200.154Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.375 168.73C534.375 173.022 532.792 179.668 532.375 182.454C531.475 190.739 528.25 214.081 526.75 225.061H591.75V180.832C591.375 179.959 589.525 176.99 585.125 172.099C579.625 165.985 569.375 158.624 557.25 159.248C545.125 159.872 541.125 163.365 537.375 168.73Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.592 132.273H364.751V217.513H445.592V132.273Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.592 217.512H364.751V237.258H445.592V217.512Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 168.988H481.466L491.645 225.75H582.25V220.188H539.812L530 168.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.719 142.852H377.877V155.985H435.719V142.852Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.719 165.504H377.438V182.03H435.719V165.504Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.125 164.375H557.875L563.25 171.375L559.125 181L570.125 222.5L548.375 221.25L556.5 181L551.375 170.5L555.125 164.375Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.026 191.66H392.556V204.355H422.026V191.66Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.726 198.311C400.412 199.281 401.617 200.163 402.082 200.592C403.772 199.418 408.665 195.117 415.443 197.525",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.726 198.311C400.412 199.281 401.617 200.163 402.082 200.592C403.772 199.418 408.665 195.117 415.443 197.525",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 220L529.25 169.5H523.25L535.75 225.312H582.75V220H540Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.191 141.102L515.313 141.102",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.377 164.252C565.3 164.024 572.29 154.391 571.991 142.736C571.693 131.082 564.218 121.819 555.295 122.048C546.373 122.276 539.383 131.909 539.681 143.563C539.98 155.217 547.455 164.48 556.377 164.252Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.629 149.469H565.77C566.255 149.469 566.654 149.877 566.613 150.357C566.051 157.066 556.178 161.327 548.211 150.3C547.96 149.959 548.205 149.469 548.629 149.469Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.901 142.539C550.877 142.539 551.668 141.748 551.668 140.773C551.668 139.798 550.877 139.008 549.901 139.008C548.925 139.008 548.134 139.798 548.134 140.773C548.134 141.748 548.925 142.539 549.901 142.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.712 142.539C564.688 142.539 565.479 141.748 565.479 140.773C565.479 139.798 564.688 139.008 563.712 139.008C562.736 139.008 561.944 139.798 561.944 140.773C561.944 141.748 562.736 142.539 563.712 142.539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.017 98L495.017 168.932",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.017 141.102H480.721",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.313 98L515.313 169.223",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.125 219.378C542.375 219.378 542 214.253 542.125 210.753C542.25 207.253 543.375 203.753 544.75 203.753C545.495 203.753 546.166 205.036 546.566 206.73C546.875 203.753 548 201.878 549.75 201.753C550.775 201.679 551.714 203.181 552.191 205.374C552.711 204.542 554.1 203.053 555.5 203.753C556.233 204.119 556.856 204.923 557.25 205.982C558.167 204.82 560.15 203.071 560.75 205.374C561.5 208.252 561.125 213.07 559.5 215.411C557.875 217.752 557.75 216.777 556.625 216.777C555.725 216.777 555.745 215.866 555.867 215.411C555.223 217.094 554.55 218.388 553.75 218.752C552.65 219.252 551.582 217.644 551.185 216.777C551.085 217.092 550.983 217.401 550.875 217.752C550.375 219.378 550.625 220.003 548.125 220.003C546.875 219.878 546.259 215.991 546.355 215.411C545.976 217.564 545.361 219.378 544.125 219.378Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.6 216.777C579.478 217.402 578.292 217.769 578 217.752C576.875 217.752 576.291 217.314 575.746 216.28C575.289 217.104 574.05 218.552 572.75 217.752C572.357 217.51 572.044 217.195 571.796 216.824C571.489 217.3 570.587 218.152 569.438 217.752C568 217.252 567.812 215.411 567.625 212.252C567.438 209.093 567.938 205.374 569.438 204.814C570.638 204.367 571.51 205.407 571.796 205.982C572.17 205.539 572.683 205.374 573.375 205.374C574.975 205.374 575.662 206.353 576.062 206.73C576.696 205.636 577.529 205.374 578 205.374C578.821 205.374 579.81 205.544 580 207.749C580.208 207.409 580.333 205.758 581.625 205.374C582.875 205.002 583.93 205.897 584.125 208.002C584.438 211.378 584.125 213.502 583.5 215.411C582.642 218.031 580.442 217.375 579.6 216.777Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.355 215.411C546.588 214.08 546.732 212.619 546.875 211.378C547.047 209.888 546.904 208.163 546.566 206.73M546.355 215.411C545.976 217.564 545.361 219.378 544.125 219.378C542.375 219.378 542 214.253 542.125 210.753C542.25 207.253 543.375 203.753 544.75 203.753C545.495 203.753 546.166 205.036 546.566 206.73M546.355 215.411C546.259 215.991 546.875 219.878 548.125 220.003C550.625 220.003 550.375 219.378 550.875 217.752C550.983 217.401 551.085 217.092 551.185 216.777M546.566 206.73C546.875 203.753 548 201.878 549.75 201.753C550.775 201.679 551.714 203.181 552.191 205.374M552.191 205.374C552.528 206.925 552.634 208.822 552.375 210.753C551.885 214.405 551.549 215.633 551.185 216.777M552.191 205.374C552.711 204.542 554.1 203.053 555.5 203.753C556.233 204.119 556.856 204.923 557.25 205.982M551.185 216.777C551.582 217.644 552.65 219.252 553.75 218.752C554.55 218.388 555.223 217.094 555.867 215.411M557.25 205.982C557.798 207.453 557.904 209.416 557.25 211.378C556.779 212.789 556.331 214.201 555.867 215.411M557.25 205.982C558.167 204.82 560.15 203.071 560.75 205.374C561.5 208.252 561.125 213.07 559.5 215.411C557.875 217.752 557.75 216.777 556.625 216.777C555.725 216.777 555.745 215.866 555.867 215.411M579.6 216.777C579.897 215.265 579.823 212.244 580 209.502C580.045 208.808 580.041 208.23 580 207.749M579.6 216.777C579.478 217.402 578.292 217.769 578 217.752C576.875 217.752 576.291 217.314 575.746 216.28M579.6 216.777C580.442 217.375 582.642 218.031 583.5 215.411C584.125 213.502 584.438 211.378 584.125 208.002C583.93 205.897 582.875 205.002 581.625 205.374C580.333 205.758 580.208 207.409 580 207.749M580 207.749C579.81 205.544 578.821 205.374 578 205.374C577.529 205.374 576.696 205.636 576.062 206.73M576.062 206.73C575.351 207.958 575 209.752 575 212.252C575 214.094 575.283 215.401 575.746 216.28M576.062 206.73C575.662 206.353 574.975 205.374 573.375 205.374C572.683 205.374 572.17 205.539 571.796 205.982M575.746 216.28C575.289 217.104 574.05 218.552 572.75 217.752C572.357 217.51 572.044 217.195 571.796 216.824M571.796 205.982C571.089 206.821 570.875 208.655 570.875 212.252C570.875 213.958 571.019 215.663 571.796 216.824M571.796 205.982C571.51 205.407 570.638 204.367 569.438 204.814C567.938 205.374 567.438 209.093 567.625 212.252C567.812 215.411 568 217.252 569.438 217.752C570.587 218.152 571.489 217.3 571.796 216.824",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.875 161.188L548.312 176.25L555.188 164.125",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.938 164.062L566.438 175.375L566.938 160.5",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.5,
    y1: 224.75,
    x2: 591.75,
    y2: 224.75,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.5,
    y1: 248.75,
    x2: 591.75,
    y2: 248.75,
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_18339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid9);
export default __webpack_public_path__ + "static/media/grid9.0d4f1622944922f0c69219db6d7928f8.svg";
export { ForwardRef as ReactComponent };